import Meta from '@/components/common/Meta'
import { META_CONTENTS } from '@/v1/constants/seo'
import GearStorageFeePage from '@/v2/components/pages/public-pages/gear-storage-fee-page'
import { faqSectionContent, ogImages } from '@/v2/constants/pages/public-pages/gear-storage-fee-page'

interface GearStorageFeePageProps {}

const Page: React.FC<GearStorageFeePageProps> = () => {
  return (
    <>
      <Meta
        title={META_CONTENTS.gear_storage_fee.title ?? ''}
        keywords={META_CONTENTS.gear_storage_fee?.keywords ?? ''}
        description={META_CONTENTS.gear_storage_fee?.description ?? ''}
        openGraph={{
          images: ogImages
        }}
        // change the passed one
        searchImages={ogImages}
        additionalData={{
          faq: faqSectionContent.questions
        }}
      />
      <GearStorageFeePage />
    </>
  )
}

export default Page
